// extracted by mini-css-extract-plugin
export default {"link":"HeadPage_link__ZTDcC","lastLink":"HeadPage_lastLink__jK1QP"};